// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import flow from 'lodash/flow';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import LinkCell from '@atlassian/jira-common-directory-v2/src/components/link-cell/view.tsx';
import { TransitionComponent } from '@atlassian/jira-common-directory-v2/src/components/transition-component/index.tsx';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import type { EntityCellProps } from '../../../../model/index.tsx';
import { getName, getViewUrl } from '../../../../state/selectors/filters/index.tsx';
import type { State } from '../../../../state/types.tsx';

type Props = JSX.LibraryManagedAttributes<typeof LinkCell, ComponentProps<typeof LinkCell>>;

const TitleLink = ({ caption, href, onClick }: Props) => (
	<TransitionComponent href={href} onClick={onClick}>
		{(props) => <LinkCell {...props} caption={caption} />}
	</TransitionComponent>
);

const mapStateToProps = () => (state: State, ownProps: EntityCellProps) => ({
	caption: getName(state, ownProps.id),
	href: getViewUrl(state, ownProps.id),
});

export default flow(
	withFireUiAnalytics({
		onClick: 'filter',
	}),
	connect(mapStateToProps, {}),
)(TitleLink);
